const DialogsContainer = ({ children }) => {
  const handleDialogsClick = (event) => {
    event.stopPropagation();
  };

  return <div onClick={ handleDialogsClick }>{children}</div>;
};

export default DialogsContainer;
